export default "__VITE_ASSET__Bna_hAz___"